
const apiConfig = {
    //apiUrl: 'https://localhost:7198/api/',
   apiUrl: 'https://mi-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

